import React, { useEffect, useState } from "react";
import ApiService from "../../Core/Service/ApiService";
import { MDBBtn, MDBCheckbox } from "mdb-react-ui-kit";
import { PriceList } from "../../Constants/constants";

const PriceSelect = React.memo(props=>{
    const [price_list, setPriceList] = useState(PriceList.map(pl=>({
        ...pl,
        checked: false
    })));

    useEffect(() => {
        if(props.initialSelectedPrices?.length > 0) {
            setPriceList(price_list.map(pl=>({
                ...pl,
                checked: props.initialSelectedPrices.includes(pl.id)
            })));
        }
    }, [props.initialSelectedPrices]);

    const selectAllPriceList = () => {
        setPriceList(price_list.map(pl=>({
            ...pl,
            checked: true
        })))
        props.onChange && props.onChange(price_list.map(pl=>pl.id));
    }
    const unSelectAllPriceList = () => {
        const new_pl = price_list.map(pl=>({
            ...pl,
            checked: false
        }));
        setPriceList(new_pl);
        props.onChange && props.onChange([]);
    }
    const invertSelectPriceList = () => {
        const new_pl = price_list.map(pl=>({
            ...pl,
            checked: !pl.checked
        }));
        setPriceList(new_pl);
        props.onChange && props.onChange(new_pl.filter(pl=>pl.checked).map(pl=>pl.id));
    }
    const handlePriceCheckChange = (e, pl_id) => {
        const new_pl = price_list.map(pl=>({
            ...pl,
            checked: pl.id == pl_id ? e.target.checked : pl.checked
        }));
        setPriceList(new_pl);
        props.onChange && props.onChange(new_pl.filter(pl=>pl.checked).map(pl=>pl.id));
    }

    return (
    <div className={`price-select ${props.className} ${props.readonly ? 'disabled-opacity-1' : ''}`}>
        <div className="d-flex align-items-center">
            <label className={`${props.required ? 'required' : ''}`}>Price List:</label>
            {!props.readonly && (<>
                <MDBBtn className="ms-4 py-1 px-2" color="link" onClick={selectAllPriceList}>Select All</MDBBtn>
                <MDBBtn className="ms-2 py-1 px-2" color="link" onClick={unSelectAllPriceList}>Select None</MDBBtn>
                <MDBBtn className="ms-2 py-1 px-2" color="link" onClick={invertSelectPriceList}>Invert Selection</MDBBtn>
            </>)}
        </div>
        <div className="d-flex flex-wrap align-items-center mt-2">
            {price_list?.map((pl, index) => (
            <div className="d-flex align-items-center me-4 mb-1" key={index} style={{minWidth: '120px'}}>
                <MDBCheckbox checked={pl.checked ?? false} onChange={e=>handlePriceCheckChange(e, pl.id)} />
                <span className="ms-1 text-nowrap">{pl.label}</span>
            </div>
            ))}
        </div>
        {props.inputError && <div className="error">{props.inputError}</div>}
    </div>
    )
});

export default PriceSelect;